














import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import Api from "../sio/Api";
import CompanyUserRequired from "@/components/CompanyRequired";
import AtRegistrationReport from "@/components/registrations/RegistrationReport.vue";
import RegistrationsPageRouteParams, {DateMode} from "@/components/registrations/RegistrationsPageRouteParams";
import rd from "@/modules/vRoutedefs";
import {ignoreRedundantNavErr} from "@/router";


@Component({
    components: {
        "at-registration-report": AtRegistrationReport,
    }
})
export default class RegistrationsPage extends CompanyUserRequired {
    @Prop({default: () => new RegistrationsPageRouteParams(null, null, DateMode.single, [], [], 1, -2, [])})
    routeParams!: RegistrationsPageRouteParams;

    @Inject()
    api!: Api;

    routeChangedBelow(n: RegistrationsPageRouteParams) {
        if(!n.equal(this.routeParams)) {
            this.queryChange(n);
        }
    }

    queryChange(rp: RegistrationsPageRouteParams) {
        ignoreRedundantNavErr(this.$router.push({name: rd.registrations.name, query: rp.routeQuery()}));
    }
}
